import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import GroupIllustration from './GroupIllustration';
import LoadingSpinner from './LoadingSpinner';

// To handle requests
import UsersAPI from '../utils/UsersAPI';
import GroupsAPI from '../utils/GroupsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';

const DEFAULT_MAX_ITEMS = 20;

/**
 * Class displaying the potential users to add to the group
 * @extends Component
 */
class UsersList extends Component {

    /**
     * Create a UsersList
     */
    constructor() {
        super();
        this.state = {
            filterText: '',
            usersItems: null,
        };

        this.handleFilter = this.handleFilter.bind(this);
        this.getUserRow = this.getUserRow.bind(this);
    }

    /**
     * Filter the users to display
     * @param {Event} e - The javascript event containing the filter value
     * @returns {void}
     */
    handleFilter(e) {
        this.setState({ filterText: e.target.value });
    }

    /**
     * Generate a JSX expression to display a row for the given user
     * @param {Object} user - Informations about the user
     * @param {String} user.UserName - The name of the user
     * @param {Number} user.UserId - The user ID
     * @return {JSX} The JSX expression for the user row
     */
    getUserRow(user) {
        const styles = {
            icon: {
                fontSize: '20px',
                marginRight: '10px',
            },
            badgeInGroup: {
                backgroundColor: '#00cc66',
                color: 'white',
            },
        };

        let selectedBadge = null;
        if (this.props.groupUsers.indexOf(user.UserName) >= 0) {
            selectedBadge = <span className="badge" style={styles.badgeInGroup}>
                Already in group
            </span>;
        } else if (this.props.selected.indexOf(user.UserName) >= 0) {
            selectedBadge = <span
              className="badge"
              style={brandingStyles.buttons.default}
            >
                <i className="fa fa-check-square-o"></i>
                &nbsp;Selected
            </span>;
        }
        if (!this.state.filterText
            || (this.state.filterText.length
            && (user.UserName.indexOf(this.state.filterText) !== -1))) {
            return (
                <li
                  className="list-group-item add-user-row clickable"
                  key={user.UserId}
                  onClick={this.props.selectFunc.bind(this, user.UserName)}
                  style={Object.assign(
                    { borderRadius: '0px' },
                    brandingStyles.backgrounds.panelSecondary
                  )}>
                    <i
                      className="fa fa-user-circle"
                      style={Object.assign({},
                        styles.icon,
                        brandingStyles.mainColor
                      )}
                    ></i>
                    <strong>{user.UserName}</strong>
                    {selectedBadge}
                </li>
            );
        }
        return null;
    }

    /**
     * Generate the JSX expression to display the user list
     * @return {JSX} The JSX expression for the user list
     */
    render() {
        const usersItems = this.props.users.map(user => this.getUserRow(user));

        return <div>
            <input
              className="form-control full-width margin-t-10"
              style={brandingStyles.backgrounds.input}
              type="text"
              placeholder="Search"
              value={this.filterText}
              onChange={this.handleFilter}/>
            <ul className="list-group">
                {usersItems}
            </ul>
        </div>;
    }
}

UsersList.propTypes = {
    users: PropTypes.array.isRequired,
    selectFunc: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
    groupUsers: PropTypes.array.isRequired,
};

/**
 * Main component to display the AddUserToGroup button
 * @extends Component
 */
class AddUserToGroupButtonComponent extends Component {

    /**
     * Create a AddUserToGroupButtonComponent
     */
    constructor() {
        super();
        const nbItemsPagination = JSON.parse(
            localStorage.getItem('scality-nbitems-add-users-to-group')
        );
        this.state = {
            showModal: false,
            selectedUsers: [],
            users: [],
            allUsers: [],
            groupUsers: [],
            step: 0,
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
            nbItems: nbItemsPagination || DEFAULT_MAX_ITEMS,
            groupUsersMarker: null,
            modalErrorAlert: '',
            dataLoaded: false,
        };
        this.refresh = this.refresh.bind(this);
        this.getAllUsersForGroup = this.getAllUsersForGroup.bind(this);
        this.handlePreviousPage = this.handlePreviousPage.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
        this.setSelectedUser = this.setSelectedUser.bind(this);
        this.selectAllUsers = this.selectAllUsers.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);
    }

    /**
     * Go to the next step
     * @returns {void}
     */
    nextStep() {
        this.setState({ step: this.state.step + 1 });
    }

    /**
     * Go to the previous step
     * @returns {void}
     */
    previousStep() {
        this.setState({ step: this.state.step - 1 });
    }

    /**
     * Open react-bootstrap modal
     * @returns {void}
     */
    openModal() {
        this.getAllUsersForGroup(this.state.groupUsersMarker, () => {
            this.refresh();
            this.setState({ showModal: true });
        });
    }

    handlePreviousPage() {
        this.setState({
            currentIndex: this.state.currentIndex - 1,
        });
    }

    handleNextPage() {
        const currentIndex = this.state.currentIndex;
        this.setState({
            currentIndex: this.state.currentIndex + 1,
        });
        if (currentIndex + 1 === this.state.allUsers.length) {
            this.refresh();
        }
    }

    getAllUsersForGroup(marker, cb) {
        // Retrieving users already in the group to make the diff
        GroupsAPI.getGroup(this.props.groupname, DEFAULT_MAX_ITEMS, marker)
        .then(res => {
            const groupUsers = this.state.groupUsers;
            for (let i = 0; i < res.users.length; i++) {
                groupUsers.push(res.users[i].UserName);
            }
            this.setState({
                groupUsers,
                groupUsersMarker: res.marker,
            });
            if (!res.marker) {
                return cb();
            }
            return this.getAllUsersForGroup(res.marker, cb);
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
        });
    }

    refresh() {
        // Retrieving users list
        UsersAPI.getUsers(this.state.nbItems, this.state.marker).then(res => {
            const userPages = this.state.allUsers;
            userPages.push(res.users);
            this.setState({
                allUsers: userPages,
                marker: res.marker,
                maxIndex: res.marker ? -1 : this.state.currentIndex,
                dataLoaded: true,
            });
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
        });
    }

    /**
     * Close react-bootstrap modal
     * @returns {void}
     */
    closeModal() {
        this.setState({
            showModal: false,
            selectedUsers: [],
            users: [],
            allUsers: [],
            groupUsers: [],
            step: 0,
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
            groupUsersMarker: null,
            modalErrorAlert: '',
        });
    }

    handleNbItemsSelect(event) {
        localStorage.setItem('scality-nbitems-add-users-to-group',
        JSON.stringify(event.target.value));
        this.setState({
            nbItems: event.target.value,
            users: [],
            allUsers: [],
            step: 0,
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
        }, this.refresh);
    }

    /**
     * Set selected user for sub component
     * @param {String} username - The name of the user
     * @returns {void}
     */
    setSelectedUser(username) {
        const tmp = this.state.selectedUsers;

        if (this.state.groupUsers.indexOf(username) === -1) {
            if (tmp.indexOf(username) >= 0) {
                tmp.splice(tmp.indexOf(username), 1);
            } else {
                tmp.push(username);
            }
        }
        this.setState({ selectedUsers: tmp });
    }

    /**
     * Select all users for sub component
     * @returns {void}
     */
    selectAllUsers() {
        const tmp = this.state.selectedUsers;
        const currentUsers = this.state.allUsers[this.state.currentIndex] || [];

        currentUsers.map(user => {
            if (this.state.groupUsers.indexOf(user.UserName) === -1) {
                tmp.push(user.UserName);
            }
            return (tmp);
        });
        this.setState({ selectedUsers: tmp });
    }

    /**
     * Catch modal submit event and process the new user
     * @returns {void}
     */
    submit() {
        // Launching add user action
        const usersArrPromises = this.state.selectedUsers.map(currentUser =>
            GroupsAPI.addUser(currentUser, this.props.groupname));

        return Promise.all(usersArrPromises).then(() => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback(this.props.groupname);
            }
        }).catch(message => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback(this.props.groupname);
            }
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else if (message.status === 409 || message.status === 400) {
                this.setState({
                    modalErrorAlert: `Error :
                    ${message.response.body.error}`,
                });
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                      server returned an Internal Error.`,
                });
            }
        });
    }

    /**
     * Generate the JSX expression to display the add user button and modal
     * @return {JSX} The JSX expression for the add user button and modal
     */
    render() {
        let modalBody;
        let modalFooter;
        // Setting up error node in case of an error
        let errorAlert = null;

        const prevDisabled = this.state.currentIndex === 0;
        const nextDisabled = this.state.currentIndex === this.state.maxIndex;

        const pagerInstance = (
          <ul className="pager padding-l-15 padding-r-15">
            <li
              className={prevDisabled ? 'previous disabled' : 'previous'}
            >
              <a
                className="clickable"
                onClick={this.handlePreviousPage}
                style={brandingStyles.buttons.primary}
              >&larr;</a>
            </li>
            <li
              className={nextDisabled ? 'next disabled' : 'next'}
            >
              <a
                className="clickable"
                onClick={this.handleNextPage}
                style={brandingStyles.buttons.primary}
              >&rarr;</a>
            </li>
          </ul>
        );

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger" style={{ marginTop: '10px' }}>
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        // If no user is selected we display the users list
        if (!this.state.step) {
            const currentUsers = this.state.allUsers[this.state.currentIndex]
                                || [];
            modalBody = <div>
                <p>
                    Please click on the users you want
                    to add into the group in the list below :
                </p>
                <div style={{
                    display: 'inline-block',
                }}>
                  <button
                    className="btn btn-primary margin-10"
                    style={brandingStyles.buttons.primary}
                    onClick={this.selectAllUsers}
                  >
                      <i className="fa fa-check-square-o"></i>
                      &nbsp;Select all
                  </button>
                </div>
                <select
                  className="pull-right form-control
                  pagination-select margin-10"
                  style={brandingStyles.backgrounds.input}
                  value={this.state.nbItems}
                  onChange={this.handleNbItemsSelect.bind(this)}>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                {
                  this.state.dataLoaded ?
                  <UsersList users={currentUsers}
                    selected={this.state.selectedUsers}
                    selectFunc={this.setSelectedUser}
                    groupUsers={this.state.groupUsers}/>
                  : <LoadingSpinner />
                }
                {pagerInstance}
            </div>;
            if (this.state.selectedUsers.length) {
                modalFooter = <div>
                    <button
                      className="btn btn-primary"
                      style={brandingStyles.buttons.primary}
                      onClick={this.nextStep}
                    >
                        Proceed
                    </button>
                </div>;
            }
        } else {
            modalBody = <div>
                <p>You are about to add users to group &nbsp;
                    <strong>{this.props.groupname}</strong>.</p>
                <hr/>
                <GroupIllustration
                  users={this.state.selectedUsers}
                  groupname={this.props.groupname}
                  icon="long-arrow-right"/>
                {errorAlert}
            </div>;

            modalFooter = <div>
                <button
                  className="btn btn-primary"
                  style={brandingStyles.buttons.primary}
                  onClick={this.submit}
                >
                    Proceed
                </button>
                <button
                  className="btn btn-primary"
                  style={brandingStyles.buttons.primary}
                  onClick={this.previousStep}
                >
                    Change selected users
                </button>
                <button
                  className="btn btn-primary"
                  style={brandingStyles.buttons.primary}
                  onClick={this.closeModal}
                >
                    Cancel
                </button>
            </div>;
        }

        return (
            <button
              className="btn btn-primary add-user-to-group-btn
              margin-r-10 margin-b-10"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-user-plus"></i>
                <span>&nbsp;</span>
                Add users to this group

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-user-plus"
                              style={brandingStyles.mainColor}>
                            </i>
                            <span>&nbsp;</span>
                            Add users to {this.props.groupname}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        {modalBody}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        {modalFooter}
                    </Modal.Footer>
                </Modal>
            </button>

        );
    }
}

// Groupname is mandatory for operation to work
AddUserToGroupButtonComponent.propTypes = {
    groupname: PropTypes.string.isRequired,
    callback: PropTypes.func,
};

export default AddUserToGroupButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/AddUserToGroupButton.js
 **/